import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 170217 171067"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528237924064">
        <path
          d="M146743 161500H23494c-888 0-1602-715-1602-1600V11167c0-885 714-1600 1602-1600h123249c888 0 1602 715 1602 1600v148733c0 885-714 1600-1602 1600zm-121669-3203h120049V12770H25074v145527z"
          className="fil0"
        />
        <path
          d="M156851 161500H13386c-888 0-1600-715-1600-1600V11167c0-885 712-1600 1600-1600h143465c885 0 1600 715 1600 1600v148733c0 885-715 1600-1600 1600zm-141883-3203h140280V12770H14968v145527z"
          className="fil0"
        />
        <path
          d="M168617 12770H1600c-886 0-1600-715-1600-1603V1600C0 714 714 0 1600 0h167017c888 0 1600 714 1600 1600v9567c0 888-712 1603-1600 1603zM3202 9567h163812V3202H3202v6365zM168617 171067H1600c-886 0-1600-715-1600-1603v-9564c0-888 714-1603 1600-1603h167017c888 0 1600 715 1600 1603v9567c0 885-712 1600-1600 1600zM3202 167864h163812v-6364H3202v6364zM139163 134881H31074c-888 0-1603-712-1603-1600V22973c0-888 715-1602 1603-1602h108089c888 0 1602 714 1602 1602v110308c0 888-734 1600-1602 1600zm-106489-3200h104889V24573H32674v107108z"
          className="fil0"
        />
        <path
          d="M44940 30591c-885 0-1600-715-1600-1600v-6000c0-886 715-1600 1600-1600 888 0 1603 714 1603 1600v6000c0 885-715 1600-1603 1600zM125276 30591c-888 0-1602-715-1602-1600v-6000c0-886 714-1600 1602-1600 886 0 1600 714 1600 1600v6000c0 885-714 1600-1600 1600zM139163 38384H31074c-888 0-1603-714-1603-1602 0-886 715-1600 1603-1600h108089c888 0 1602 714 1602 1600 0 888-734 1602-1602 1602z"
          className="fil0"
        />
        <path
          d="M44940 44382c-885 0-1600-715-1600-1600v-6000c0-886 715-1600 1600-1600 888 0 1603 714 1603 1600v6000c0 885-715 1600-1603 1600zM125276 44382c-888 0-1602-715-1602-1600v-6000c0-886 714-1600 1602-1600 886 0 1600 714 1600 1600v6000c0 885-714 1600-1600 1600zM139163 52155H31074c-888 0-1603-714-1603-1600 0-888 715-1602 1603-1602h108089c888 0 1602 714 1602 1602 0 886-734 1600-1602 1600z"
          className="fil0"
        />
        <path
          d="M44940 58173c-885 0-1600-715-1600-1600v-6018c0-888 715-1602 1600-1602 888 0 1603 714 1603 1602v5998c0 905-715 1620-1603 1620zM125276 58173c-888 0-1602-715-1602-1600v-6018c0-888 714-1602 1602-1602 886 0 1600 714 1600 1602v5998c0 905-714 1620-1600 1620zM139163 65946H31074c-888 0-1603-714-1603-1600 0-888 715-1602 1603-1602h108089c888 0 1602 714 1602 1602 0 886-734 1600-1602 1600z"
          className="fil0"
        />
        <path
          d="M44940 71964c-885 0-1600-715-1600-1600v-6000c0-886 715-1600 1600-1600 888 0 1603 714 1603 1600v6000c0 868-715 1600-1603 1600zM125276 71964c-888 0-1602-715-1602-1600v-6000c0-886 714-1600 1602-1600 886 0 1600 714 1600 1600v6000c0 868-714 1600-1600 1600zM139163 79737H31074c-888 0-1603-714-1603-1600 0-888 715-1602 1603-1602h108089c888 0 1602 714 1602 1602 0 886-734 1600-1602 1600z"
          className="fil0"
        />
        <path
          d="M44940 85737c-885 0-1600-714-1600-1602v-5998c0-888 715-1602 1600-1602 888 0 1603 714 1603 1602v5998c0 888-715 1602-1603 1602zM125276 85737c-888 0-1602-714-1602-1602v-5998c0-888 714-1602 1602-1602 886 0 1600 714 1600 1602v5998c0 888-714 1602-1600 1602zM139163 93528H31074c-888 0-1603-714-1603-1600 0-888 715-1602 1603-1602h108089c888 0 1602 714 1602 1602 0 886-734 1600-1602 1600z"
          className="fil0"
        />
        <path
          d="M44940 99526c-885 0-1600-712-1600-1600v-5998c0-888 715-1602 1600-1602 888 0 1603 714 1603 1602v5998c0 888-715 1600-1603 1600zM125276 99526c-888 0-1602-712-1602-1600v-5998c0-888 714-1602 1602-1602 886 0 1600 714 1600 1602v5998c0 888-714 1600-1600 1600zM139163 107319H31074c-888 0-1603-714-1603-1600 0-888 715-1602 1603-1602h108089c888 0 1602 714 1602 1602 0 886-734 1600-1602 1600z"
          className="fil0"
        />
        <path
          d="M44940 113317c-885 0-1600-712-1600-1600v-5998c0-888 715-1602 1600-1602 888 0 1603 714 1603 1602v5998c0 888-715 1600-1603 1600zM125276 113317c-888 0-1602-712-1602-1600v-5998c0-888 714-1602 1602-1602 886 0 1600 714 1600 1602v5998c0 888-714 1600-1600 1600zM139163 121110H31074c-888 0-1603-714-1603-1600 0-888 715-1602 1603-1602h108089c888 0 1602 714 1602 1602 0 886-734 1600-1602 1600z"
          className="fil0"
        />
        <path
          d="M44940 127108c-885 0-1600-712-1600-1600v-5998c0-888 715-1602 1600-1602 888 0 1603 714 1603 1602v5998c0 888-715 1600-1603 1600zM125276 127108c-888 0-1602-712-1602-1600v-5998c0-888 714-1602 1602-1602 886 0 1600 714 1600 1602v5998c0 888-714 1600-1600 1600zM56417 24593c-886 0-1600-714-1600-1602V11167c0-885 714-1600 1600-1600 888 0 1602 715 1602 1600v11824c18 888-714 1602-1602 1602zM113800 24593c-888 0-1600-714-1600-1602V11167c0-885 712-1600 1600-1600s1600 715 1600 1600v11824c0 888-732 1602-1600 1602zM121689 153012c-5306 0-9605-4299-9605-9605 0-886 712-1600 1600-1600h16010c885 0 1600 714 1600 1600 20 5306-4302 9605-9605 9605zm-6191-8003c712 2758 3220 4803 6209 4803 2971 0 5496-2045 6211-4803h-12420z"
          className="fil0"
        />
        <path
          d="M121689 145009c-888 0-1603-714-1603-1602v-10106c0-888 715-1602 1603-1602 885 0 1600 714 1600 1602v10106c20 888-715 1602-1600 1602z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
